export const T = {
  en_GB: {
    upcoming: "Upcoming",
    upcomingNone: "No upcoming meetings.",
    pastTitle: "Recent activity",
    pastNone: "No activity logged yet.",
    new: "Add",
    newFlow: "Flow",
    newMeeting: "Meeting",
    newCall: "Call",
    newNote: "Note",
    columnDate: "Date",
    columnUpdated: "Updated",
    columnType: "Type",
    columnTopic: "Topic",
    columnSubject: "Subject",
    columnSummary: "Summary",
    columnEvent: "Event",
    columnBy: "By",
    note: "Note",
    call: "Call",
    meeting: "Meeting",
    flow: "Flow",
    created: "Created",
    submitted: "Submitted",
    unlocked: "Unlocked for editing",
    drafted: "Returned to draft",
    reopened: "Reopened",
    cancelled: "Cancelled",
    completed: "Completed",
    signed: "Signed",
    pdfGenerated: "PDF generated",
    noContent: "No content",
    today: "today",
    yesterday: "yesterday",
    tomorrow: "tomorrow",
    daysAgo: (n: number) => `${n} days ago`,
    inDays: (n: number) => `in ${n} days`,
  },
  nb_NO: {
    upcoming: "Kommende",
    upcomingNone: "Ingen kommende møter.",
    pastTitle: "Nylig aktivitet",
    pastNone: "Ingen aktivitet registrert enda.",
    new: "Legg til",
    newFlow: "Flyt",
    newMeeting: "Møte",
    newCall: "Samtale",
    newNote: "Notat",
    columnDate: "Dato",
    columnUpdated: "Oppdatert",
    columnType: "Type",
    columnTopic: "Tema",
    columnSubject: "Emne",
    columnSummary: "Sammendrag",
    columnEvent: "Hendelse",
    columnBy: "Av",
    note: "Notat",
    call: "Samtale",
    meeting: "Møte",
    flow: "Flyt",
    created: "Opprettet",
    submitted: "Sendt inn",
    unlocked: "Låst opp for redigering",
    drafted: "Tilbake til utkast",
    reopened: "Gjenåpnet",
    cancelled: "Kansellert",
    completed: "Fullført",
    signed: "Signert",
    pdfGenerated: "PDF generert",
    noContent: "Ingen innhold",
    today: "i dag",
    yesterday: "i går",
    tomorrow: "i morgen",
    daysAgo: (n: number) => `${n} dager siden`,
    inDays: (n: number) => `om ${n} dager`,
  },
} as const;
